import { renderTemplate } from "../templateRenderer";
import { BUSINESS_REPORT_TEMPLATE, BUSINESS_REPORT_CSS } from "./loader";

export interface ReportStatItem {
  title: string;
  value: string | number;
  colorClass?: string;
}

export interface BusinessReportTemplateContext {
  title: string;
  description?: string;
  storeName?: string;
  address?: string;
  phone?: string;
  email?: string;
  logoUrl?: string;
  generatedAt?: string;
  selectedStoresLabel?: string;
  stats?: ReportStatItem[];
  reportHtmlContent: string;
  orientation?: "portrait" | "landscape";
  isForPrint?: boolean;
}

const BASE_TEMPLATE = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8"/>
  <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
  <title>{{ title }} - {{ companyName }}</title>
  <style>
    @page { size: A4 {{ orientation }}; margin: 10mm; }
    body { padding: {{ "0" if isForPrint else "16px" }}; background-color: {{ "#ffffff" if isForPrint else "#f8fafc" }}; }
    {{ styles | safe }}
  </style>
</head>
<body>
  {{ content | safe }}
</body>
</html>`;

export function renderBusinessReport(
  ctx: BusinessReportTemplateContext,
): string {
  const companyName = ctx.storeName || "POS SYSTEM";
  const generatedAt = ctx.generatedAt || new Date().toLocaleString();
  const dateLabel = generatedAt.split(" ")[0];
  const selectedStoresLabel = ctx.selectedStoresLabel || "All Stores";
  const orientation = ctx.orientation || "portrait";
  const isForPrint = ctx.isForPrint ?? false;

  const contentContext = {
    ...ctx,
    companyName,
    generatedAt,
    dateLabel,
    selectedStoresLabel,
    orientation,
    isForPrint,
  };

  const content = renderTemplate(BUSINESS_REPORT_TEMPLATE, contentContext);

  return renderTemplate(BASE_TEMPLATE, {
    title: ctx.title,
    companyName,
    orientation,
    isForPrint,
    styles: BUSINESS_REPORT_CSS,
    content,
  });
}

